export const TOOLTIP_DELAY = 300;

export const REACTION_POPOVER_HIDE_DELAY = 600;
